import './InputCustomInstruction.css';

const InputCustomInstruction = ({ instruction, handleInstructionChange, inputMessage, handleInstructionSubmit, isInstructionSubmitted, loadingLLMResponse }) => {
  return (
    <div className="input-custom-container">
      <textarea 
        className="instruction-textarea"
        placeholder="Enter your instructions to call the patient"
        value={instruction}
        onChange={handleInstructionChange}
      ></textarea>
      <span className="input-hint">&#x24D8; {inputMessage}</span>
      <button 
        className="add-patient-button"
        onClick={handleInstructionSubmit}
        disabled={!instruction.trim() || isInstructionSubmitted || loadingLLMResponse}
      >
        {loadingLLMResponse ? 'Processing…' : 'Add Patients Information'}
      </button>
    </div>
  );
};

export default InputCustomInstruction;